<template>

  <div id="app">
  	<div id="Loading">
		<div class="loader-inner ball-beat">
			<div></div>
			<div></div>
			<div></div>
		</div>
	</div>
    <router-view/>
    <FooterBar v-show="$route.meta.showFooter"/>
  </div>
</template>

<script>
import Vue from 'vue'
import FooterBar from '@/components/FooterBar/FooterBar'

export default {
  components: {
    FooterBar
  },
  mounted(){
  	let loading=document.getElementById('Loading');
  	if(loading){
  		loading.parentNode.removeChild(loading);
  	}
  }
}
</script>

<style type="text/css">
#Loading{
	top:0;
	left:0;
	width:100%;
	height:100%;
	position:fixed;
	background:#fff;
	z-index:100;
}
@-webkit-keyframes ball-beat{
	50%{
		opacity:0.2;
		-webkit-transform:scale(0.75);
		transform:scale(0.75);
	}
	100%{
		opacity:1;
		-webkit-transform:scale(1);
		transform:scale(1);
	}
}
@keyframes ball-beat{
	50%{
		opacity:0.2;
		-webkit-transform:scale(0.75);
		transform:scale(0.75);
	}
	100%{
		opacity:1;
		-webkit-transform:scale(1);
		transform:scale(1);
	}
}
.ball-beat{
	top:50%;
	left:50%;
	position:absolute;
	width:60px;
	height:10px;
	margin-left:-30px;
}
.ball-beat > div{
	
	background-color:#333;
	width:10px;
	height:10px;
	border-radius:100%!important;
	margin:2px;
	-webkit-animation-fill-mode:both;
	display:inline-block;
	-webkit-animation:ball-beat 0.7s 0s infinite linear;
	animation:ball-beat 0.7s 0s infinite linear;
}
.ball-beat > div:nth-child(2n-1){
	-webkit-animation-delay:0.35s!important;
	animation-delay:0.35s!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue